import React, { useState, useEffect } from "react";
import DashboardLayout from "../DashboardLayout";
import {
  fetchFAQsCategories,
  fetchFAQsList,
} from "../../services/axios/apiManager";
import FaqCategories from "./faqCategories";
import FaqsList from "./faqsList";
import { useAppContext } from "../../services/context";
import { handleErrors } from "../../services/dataManager";
const FAQs = ({ navigate }) => {
  const { state } = useAppContext();
  const { permissions } = state;
  const [faqs, setFaqs] = useState([]);
  const [faqCategories, setFaqCategories] = useState([]);
  const [pagination, setPagination] = useState({});
  const [granted, setGranted] = useState([]);
  const [catsPermsgranted, setCatsPermsgranted] = useState([]);

  const extractPermissions = () => {
    const perms = permissions.filter((f) => f.module === "FAQs");
    if (perms) {
      setGranted(perms);
    }
    const catsPerms = permissions.filter((f) => f.module === "FAQs_Categories");
    if (catsPerms) {
      setCatsPermsgranted(catsPerms);
    }
  };

  const getData = async () => {
    const res = await fetchFAQsList();
    if (res?.data?.success && res?.data?.data) {
      setFaqs(res.data.data);
      if (res?.data?.pagination) {
        setPagination(res.data.pagination);
      }
    } else {
      handleErrors(res, navigate);
    }
    const categoriesResponse = await fetchFAQsCategories();
    if (categoriesResponse?.data?.data) {
      setFaqCategories(categoriesResponse.data.data);
    }
  };

  useEffect(() => {
    extractPermissions();
    // const getData = async () => {
    //   const res = await fetchFAQsList();
    //   if (res?.data?.success && res?.data?.data) {
    //     setFaqs(res.data.data);
    //     if (res?.data?.pagination) {
    //       setPagination(res.data.pagination);
    //     }
    //   } else {
    //     handleErrors(res, navigate);
    //   }
    //   const categoriesResponse = await fetchFAQsCategories();
    //   if (categoriesResponse?.data?.data) {
    //     setFaqCategories(categoriesResponse.data.data);
    //   }
    // };
    getData();
  }, []);
  return (
    <DashboardLayout>
      <div className="text-light container">
        <div className="row">
          <div className="col-12 mb-3">
            <div className="page-title-box d-sm-flex align-items-center justify-content-between">
              <div className="page-title-right">
                <ol className="breadcrumb m-0">
                  <li className="breadcrumb-item">
                    <a>Management</a>
                  </li>
                  <li
                    className="breadcrumb-item active"
                    style={{ color: "#d1cdcdbf" }}
                    data-testid="faqsHeading"
                  >
                    FAQs
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>
        <FaqCategories
          faqCategories={faqCategories}
          setFaqCategories={setFaqCategories}
          catsPermsgranted={catsPermsgranted}
          getData={getData}
        />
        <FaqsList
          faqs={faqs}
          setFaqs={setFaqs}
          faqCategories={faqCategories}
          pagination={pagination}
          setPagination={setPagination}
          granted={granted}
        />
      </div>
    </DashboardLayout>
  );
};

export default FAQs;
